<template lang="pug">
  .macedonia
    .title-img-wrap
      .img-bg
      img(
      src="@/assets/images/countries/macedonia-min.png"
      )
      span {{ gettext('Македония') }}
    p.type-thin {{ gettext('Общие данные о стране') }}
    .content.one-grid
      div
        p {{ gettext('Македония – страна со славным историческим прошлым, этнической родиной Александра Македонского. Она является соседкой Греции, с которой до сих пор идут споры о названии Македонии и зависящего от этого присоединения территории. Население страны составляет около 2 млн. Македония вместе с остальными странами Балканского полуострова является официальным кандидатом на членство в Евро союзе. Статус кандидата не дает македонцам право на работу в странах ЕС без разрешения.') }}
        p {{ gettext('Македонцы весьма патриотичная нация, они открытые, веселые, искренние и любят общение. Македонская диаспора пустила корни в множестве стран: США, Австралия, Бельгия, Германия, Италия, Скандинавские страны и другие, а общую численность мобильных македонцев можно сравнить с численностью населения страны.') }}
        p {{ gettext('Македонцы хороши как работники в сельском хозяйстве, так как в горных районах Македонии популярно разведение овец, а в других – выращивают фрукты и орехи и многие жители связаны с этим занятием. Также достаточно большое количество македонцев занято в сфере обслуживания в связи с развитой туристической сферой. Но в основном получить работу в Македонии очень непросто, получить её можно только «по знакомству», поэтому много македонцев работает заграницей, в тех же сферах, а также в строительстве, производстве, помощи по дому и торговле, транспорта, здравоохранении, социальных услуг и других. В принципе, в любой сфере занятости можно встретить успешного работника – македонца.') }}
        p {{ gettext('В своей стране македонцы получают достаточно качественное образование, многие молодые люди знают английский язык и свободно на нем общаются, некоторые из македонцев работают по специальности, подтвердив свои дипломы в других странах.') }}
        p {{ gettext('Их часто характеризуют как совестных работников, умеющих быстро учится и хорошо выполнять свою работу.') }}
        router-link(:to="`/${getLanguage}/countries`")
          button.main-btn.bg-transparent.google
            | {{ gettext('See other countries') }}
</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import mixin from '@/mixins'

export default {
  props: ['country'],
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo, sharedImg: document.location.origin + 'webapp/images/countries/macedonia-min.png'})
  },
  name: 'Macedonia',
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Macedonia | ' + gettext('Countries'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='../country/styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/macedonia/index.vue